<template>

  <v-container fluid class="px-0 order-info-overview">

    <!-- Order Summary -->
    <order-summary
        class="page-content"
        :order="order" />

    <!-- Order Send Email Action -->
    <order-send-email-action
        class="page-content mt-4"
        :order="order" />

    <!-- Provider Compare and Sync Utilities -->
    <order-provider-data-sync
        v-if="showProviderDataSync"
        class="page-content mt-4"
        :order="order"
        @updated="reloadOrderData" />

    <!-- Shipper and Receiver Info -->
    <v-container fluid class="page-content mt-4">
      <v-row>
        <v-col cols="12" xs="12" sm="12" md="12" lg="6" class="pa-0">
          <order-shipper-info
              :title="(isCredit) ? 'Credit From' : 'Shipping From'"
              :order="order" />
        </v-col>
        <v-col cols="12" xs="12" sm="12" md="12" lg="6" class="pa-0">
          <order-receiver-info
              :title="(isCredit) ? 'Credit To' : 'Shipping To'"
              :order="order" />
        </v-col>
      </v-row>
    </v-container>

    <!-- Ordered Items -->
    <v-expansion-panels flat accordion class="mt-4" v-model="isShipmentDetailsActive">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div class="px-2 title">
            <span>{{ shipmentDetailsTitle }}</span>
            <span style="color:#9c9c9c;" class="pl-3">({{totalItems}})</span>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="px-4">
          <order-shipment-details
              class="mb-5"
              :order="order" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- Order Invoice Viewer -->
    <order-invoice-viewer
        v-if="canViewInvoice"
        class="page-content mt-4"
        :order="order" />
  </v-container>

</template>

<script>
import OrderSummary from '@/components/orders/OrderSummary'
import OrderSendEmailAction from '@/components/orders/OrderSendEmailAction'
import OrderProviderDataSync from '@/components/orders/OrderProviderDataSync'
import OrderShipmentDetails from '@/components/orders/OrderShipmentDetails'
import OrderShipperInfo from '@/components/orders/OrderShipperInfo'
import OrderReceiverInfo from '@/components/orders/OrderReceiverInfo'
import OrderInvoiceViewer from '@/components/orders/OrderInvoiceViewer'

export default {
  name: 'OrderInfoOverview',

  components: {
    OrderSummary,
    OrderSendEmailAction,
    OrderProviderDataSync,
    OrderShipperInfo,
    OrderReceiverInfo,
    OrderShipmentDetails,
    OrderInvoiceViewer
  },

  props: {
    orderId: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      isShipmentDetailsActive: false
    }
  },

  computed: {
    order () {
      return this.$parent.order
    },
    canViewInvoice () {
      return this.order.order_status !== 'BEING_SCHEDULED'
    },
    isCredit () {
      return this.order.is_credit
    },
    orderedItems () {
      return this.order.order_details.item_data.items
    },
    totalItems () {
      return this.orderedItems.length
    },
    shipmentDetailsTitle () {
      return (this.isCredit)
        ? 'Credited Items'
        : 'Ordered Items'
    },
    showProviderDataSync () {
      return this.order.order_status !== 'CANCELED' &&
        this.order.order_status !== 'REJECTED_ON_DELIVERY' &&
        this.order.order_status !== 'RESCHEDULED'
    }
  },

  methods: {
    toggleShipmentView () {
      this.isShipmentDetailsActive = !this.isShipmentDetailsActive
    },

    async reloadOrderData (eventType) {
      return this.$parent.reloadOrderData()
    }
  }
}
</script>

<style>
  .order-info-overview .theme--dark.v-expansion-panels .v-expansion-panel {
    background-color: #161616;
    border: 1px solid #262626;
  }

  .order-info-overview .v-expansion-panel--active>.v-expansion-panel-header {
    min-height: unset;
  }

  .order-info-overview .v-expansion-panel-content__wrap {
    padding-left: 0px;
  }
</style>
